import "lightgallery.js";
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import { app } from '../../utils/store';

gsap.registerPlugin(ScrollTrigger);

export default class Gallery{
    constructor(){
        this.header = document.querySelector('header');

        this.gallery = {
            container: document.getElementById('gallery'),
            image: document.querySelectorAll('#gallery img'),
            item_gallery: document.querySelectorAll('li.item-gallery'),
        };
        this.btn = {
            gallery : document.getElementById('btn-gallery'),
        }

        this.lightbox = {
            container: document.getElementById('gallery'),
            toggler: document.querySelectorAll('#gallery li'),
        };
    }

    init() {
        if(this.gallery.container){
            this.toggle();
        }
    }

    toggle = () => {
        this.btn.gallery.addEventListener('click', (e) => {
            e.preventDefault();
            this.gallery.item_gallery.forEach((element) => {
                element.classList.remove('d-none');
            });
            this.btn.gallery.classList.add('d-none');
        });
        // document.querySelector('body').classList.add('lg-casestudy');

        lightGallery(this.lightbox.container, {
            mode: 'lg-fade',
            startClass: 'lg-start-fade',
            keypress: true,
            controls: true,
            download: false,
            counter: false,
            enableDrag: false,
            enableTouch: false,
            enableSwipe: true,
            useLeft: true,
            hideControlOnEnd: true,
        });


        // this.gallery.image.forEach((toggler) => {
        //     toggler.addEventListener('click', (e) => {
        //         var target = e.target.getAttribute('src');
        //         this.lightbox.container.querySelector('[data-src="' + target + '"').click();
        //     });
        // });

        // this.lightbox.container.addEventListener('onBeforeOpen', () => {
        //     this.header.classList.add('lg-active');
        //     document.querySelector('body').classList.toggle('overflow-hidden');
        // });

        // this.lightbox.container.addEventListener('onBeforeClose', () => {
        //     this.header.classList.remove('lg-active');
        //     document.querySelector('body').classList.toggle('overflow-hidden');
        // });
    }

    animation = () => {
        // Animate using GSAP
    }
}
